module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item9-350dca196b7887e70524dd80a1db1ea0.svg";